import { cn } from './cn';

export interface AppLogoProps {
  readonly size?: 'sm' | 'md';
  readonly className?: string;
}

const MARK_SIZE: Record<'sm' | 'md', string> = {
  sm: 'h-6 w-6',
  md: 'h-8 w-8',
};

const LABEL_SIZE: Record<'sm' | 'md', string> = {
  sm: 'text-sm font-medium',
  md: 'text-base font-semibold',
};

// Horizontal lockup: mark + wordmark on one line (Product Owner-approved option C).
// The mark is three decreasing-length bars — a debt shrinking over time, echoing the
// aging-bucket visual language used elsewhere (AgingBar/AgingBadge) — rendered in
// currentColor so it inherits the shared primary token and follows theme automatically.
export function AppLogo({ size = 'md', className }: AppLogoProps): JSX.Element {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <svg
        viewBox="0 0 40 40"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
        className={cn('shrink-0 text-primary', MARK_SIZE[size])}
      >
        <rect x="6" y="9" width="28" height="4" rx="2" />
        <rect x="6" y="18" width="20" height="4" rx="2" opacity="0.62" />
        <rect x="6" y="27" width="11" height="4" rx="2" opacity="0.34" />
      </svg>
      <span className={cn('text-fg', LABEL_SIZE[size])}>დებიტორების მართვა</span>
    </span>
  );
}
